// extracted by mini-css-extract-plugin
module.exports = {"MultiStateWrapper":"MultiStateToggle_MultiStateWrapper__1f1cN","Option":"MultiStateToggle_Option__399CY","Active":"MultiStateToggle_Active__1jdVH"};